import React from 'react'

const footerLinks = [
    {
        title:"Quick Links",
        links:[
            {
                name:"Home",
                link:"#"
            },
            {
                name:"About",
                link:"#"
            },
            {
                name:"Locations",
                link:"#"
            },
            {
                name:"Shop",
                link:"#"
            },
            {
                name:"Contact",
                link:"#"
            }
        ]
    },
    {
        title:"Quick Links",
        links:[
            {
                name:"Home",
                link:"#"
            },
            {
                name:"About",
                link:"#"
            },
            {
                name:"Locations",
                link:"#"
            },
            {
                name:"Shop",
                link:"#"
            },
            {
                name:"Contact",
                link:"#"
            }
        ]
    },
    {
        title:"Company",
        links:[
            {
                name:"Facebook",
                link:"#"
            },
            {
                name:"Instagram",
                link:"#"
            },
            {
                name:"Twitter",
                link:"#"
            }
        ]
    }
]

export default function Footer() {
  return (
    <footer className="footer-section">
        <div className="footer-top">
            <div className="container"> 
                <div className="row"> 
                    <div className="col-lg-4 mb-3 mb-lg-0 text-center text-lg-start d-flex align-items-center">
                        <p className='w-100'>Designed in Calirfornia. Must be <br /> legal drinking age to view and <br /> share. Please drink responsibly.</p>
                    </div>
                    {footerLinks.map((footerItem, index)=>{ 
                        return(
                            <div className="col-lg-2 col-6 mb-3" key={index}>
                                <div className="footer-text-item"> 
                                    <h4 className="footer-title">{footerItem.title}</h4>
                                    <ul className="link-block">
                                        {footerItem.links.map((linkItem, index) => <li key={index}><a href={linkItem.link}>{linkItem.name}</a></li>)}
                                    </ul>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <p>All Rights Reserved. © 2022 Saint Cloud</p>
        </div>
    </footer>
  )
}
